import { Component, OnInit } from '@angular/core';
import {DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor(
    private __ref: DynamicDialogRef,
  ) { }

  ngOnInit(): void {
  }

  cancel() {
    let data = {
      accion: 'cancel'
    }
    this.__ref.close(data);
  }

  accept() {
    let data = {
      accion: 'accept'
    }
    this.__ref.close(data);
  }

}
